
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishing/media-library",
      function () {
        return require("private-next-pages/publishing/media-library.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishing/media-library"])
      });
    }
  